export default __webpack_public_path__ + "static/possibleMobile-98a08c470f61b52d7554f02b13506573.png";